import React from "react";
import DeltaBadge from "./DeltaBadge";

const fmt = (value, format, currency = "AED") => {
  if (value == null) return "—";
  switch (format) {
    case "currency": return `${currency} ${Number(value).toLocaleString("en", { minimumFractionDigits: 0 })}`;
    case "percent":  return `${Number(value).toFixed(1)}%`;
    case "hours":    return `${value}h`;
    case "decimal":  return Number(value).toFixed(1);
    default:         return Number(value).toLocaleString("en");
  }
};

const KPICard = ({ icon: Icon, label, current, previous, format = "number", metricKey, invertDelta, currency = "AED", style = {}, animDelay = 0, iconColor = "#2563EB", iconBackground = "#EFF6FF" }) => (
  <div style={{
    background: "#fff",
    border: "1px solid #E5E7EB",
    borderRadius: "8px",
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    animation: `fadeSlideUp 0.4s ease-out ${animDelay}ms both`,
    ...style,
  }}>
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
      <span style={{ fontSize: "13px", fontWeight: "500", color: "#6B7280" }}>{label}</span>
      {Icon && (
        <span style={{ color: iconColor, background: iconBackground, borderRadius: "6px", padding: "6px", display: "flex" }}>
          <Icon size={16} />
        </span>
      )}
    </div>
    <div>
      <div style={{ fontSize: "28px", fontWeight: "700", color: "#111827", lineHeight: 1.2 }}>
        {fmt(current, format, currency)}
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: "6px" }}>
        <DeltaBadge current={current} previous={previous} metricKey={metricKey} invertColor={invertDelta} />
        {previous != null && (
          <span style={{ fontSize: "12px", color: "#9CA3AF" }}>vs {fmt(previous, format, currency)}</span>
        )}
      </div>
    </div>
  </div>
);

export default KPICard;
